import { useAppDispatch, useAppSelector } from "@/app/lib/features/redux/redux.hook";
import { useCallback } from "react";
import { show, hide, setLoading } from "./alertDialog.slice";
import { AlertDialogItem } from "./alertDialog.types";

const useAlertDialog = () => {
  const dispatch = useAppDispatch();
  const { alertDialog, isLoading } = useAppSelector((state) => state.alertDialog);

  const showAlertDialog = useCallback(
    (config: AlertDialogItem) => {
      dispatch(show(config));
    },
    [dispatch],
  );

  const hideAlertDialog = useCallback(() => {
    dispatch(hide());
  }, [dispatch]);

  const setAlertDialogLoading = useCallback(
    (loading: boolean) => {
      dispatch(setLoading(loading));
    },
    [dispatch],
  );

  return {
    alertDialog,
    isLoading,
    showAlertDialog,
    hideAlertDialog,
    setAlertDialogLoading,
  };
};

export default useAlertDialog;